import { WeekDays } from "common/Calendars/types.ts";

export const MAX_DAY_END_TIME: [number, number, number, number] = [
  23, 59, 59, 999,
];

export const WEEKEND_DAYS = [WeekDays.SATURDAY, WeekDays.SUNDAY];

export const NIGHT_HOURS = [22, 8];

export const WEEK_DAYS = [
  WeekDays.SUNDAY,
  WeekDays.MONDAY,
  WeekDays.TUESDAY,
  WeekDays.WEDNESDAY,
  WeekDays.THURSDAY,
  WeekDays.FRIDAY,
  WeekDays.SATURDAY,
];

export const WEEK_DAY_TO_DISPLAY_NAME = {
  [WeekDays.SUNDAY]: "Sunday",
  [WeekDays.MONDAY]: "Monday",
  [WeekDays.TUESDAY]: "Tuesday",
  [WeekDays.WEDNESDAY]: "Wednesday",
  [WeekDays.THURSDAY]: "Thursday",
  [WeekDays.FRIDAY]: "Friday",
  [WeekDays.SATURDAY]: "Saturday",
};

export const TIME_FORMAT = "hh:mm A";
